import React from 'react';
import { motion } from 'framer-motion';
import { Layers, MapPin, Users, Zap } from 'lucide-react';
import { InteriorSlide, SlideHeader, SlideBanner } from './SlideShell';
import type { SlideProps } from './SlideShell';
export function Slide10Contacts({
  index
}: SlideProps) {
  const points = [{
    icon: Layers,
    title: 'The same model, applied to your four priority brands'
  }, {
    icon: MapPin,
    title: 'Campaigns that work in Ivory Coast, West Africa — and beyond'
  }, {
    icon: Users,
    title: 'A single partner who understands the African HCP landscape'
  }, {
    icon: Zap,
    title: 'You focus on your brands. We handle the execution.'
  }];
  return <InteriorSlide banner={<SlideBanner eyebrow="The Bottom Line" data-id="element-228">
          Arnaud, you already have the content. You already have the channels.
          What you need is someone to make them work together — consistently,
          compliantly, and at scale.
        </SlideBanner>} data-id="element-227">
      <SlideHeader eyebrow="Impact" data-id="element-229">
        What This Means for Roche Africa
      </SlideHeader>

      <div className="flex-1 flex flex-col lg:flex-row items-center gap-12 lg:gap-16 max-w-6xl mx-auto w-full" data-id="element-230">
        {/* Left: Content */}
        <div className="flex-1 w-full" data-id="element-231">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-232">
            {points.map((point, i) => {
            const Icon = point.icon;
            return <motion.div key={i} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: 0.3 + i * 0.1,
              duration: 0.6
            }} className="bg-white rounded-3xl p-6 shadow-sm border border-black/5 flex flex-col items-center text-center" data-id="element-233">
                  <div className="h-12 w-12 rounded-full bg-[var(--surface)] flex items-center justify-center text-[var(--brand)] mb-4" data-id="element-234">
                    <Icon className="h-6 w-6" data-id="element-235" />
                  </div>
                  <h3 className="text-lg font-bold text-[var(--fg)] leading-snug" data-id="element-236">
                    {point.title}
                  </h3>
                </motion.div>;
          })}
          </div>
        </div>

        {/* Right: Visual */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.4,
        duration: 0.8
      }} className="flex-1 w-full relative aspect-[4/5] max-w-md rounded-3xl overflow-hidden shadow-2xl border-8 border-white" data-id="element-237">
          <img src="https://images.unsplash.com/photo-1622902046580-2b47f47f5471?w=1200&q=80" alt="African doctor and patient in consultation" className="w-full h-full object-cover" data-id="element-238" />
          <div className="absolute inset-0 bg-gradient-to-t from-[var(--brand)]/60 via-transparent to-transparent mix-blend-multiply" data-id="element-239" />
        </motion.div>
      </div>
    </InteriorSlide>;
}